import * as React from 'react';

interface ISubmenuProps {
  label: string;
  children: React.ReactChild;
}

class Submenu extends React.Component<ISubmenuProps> {
  render() {
    const { label, children } = this.props;
    return (
      <li className="group submenu inline-block relative px-3 pt-3 pb-1">
        <span className="relative z-20">{label}</span>
        <ul className="hidden group-hover:block list-reset text-xl absolute z-10 pin-t pin-l pin-r bg-grey pt-12 border border-white shadow-lg">
          {children}
        </ul>
      </li>
    );
  }
}

export default Submenu;



// WEBPACK FOOTER //
// ./src/components/Header/components/Submenu.tsx